module.exports = __webpack_public_path__ + "img/Icon-metro-attachment.3352a983.svg";